(() => {
  'use strict';

  const STORAGE_KEY = 'inobox_support_session_v1';
  const HISTORY_KEY_PREFIX = 'inobox_support_history_v1_';
  const MAX_HISTORY_MESSAGES = 40;

  function newSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `web-${window.crypto.randomUUID()}`;
    }
    return `web-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
  }

  function getSessionId() {
    try {
      let sessionId = window.localStorage.getItem(STORAGE_KEY);
      if (!sessionId) {
        sessionId = newSessionId();
        window.localStorage.setItem(STORAGE_KEY, sessionId);
      }
      return sessionId;
    } catch (error) {
      console.warn('[INOBOX Support] localStorage indisponível', error);
      return newSessionId();
    }
  }

  function getHistoryKey(sessionId) {
  return `${HISTORY_KEY_PREFIX}${sessionId}`;
}

function loadHistory(sessionId) {
  try {
    const raw = window.localStorage.getItem(getHistoryKey(sessionId));

    if (!raw) return [];

    const history = JSON.parse(raw);

    if (!Array.isArray(history)) return [];

    return history
      .filter((item) => (
        item &&
        typeof item.text === 'string' &&
        ['user', 'assistant'].includes(item.role)
      ))
      .slice(-MAX_HISTORY_MESSAGES);
  } catch (error) {
    console.warn('[INOBOX Support] Histórico indisponível', error);
    return [];
  }
}

function saveHistory(sessionId, history) {
  try {
    window.localStorage.setItem(
      getHistoryKey(sessionId),
      JSON.stringify(history.slice(-MAX_HISTORY_MESSAGES))
    );
  } catch (error) {
    console.warn('[INOBOX Support] Não foi possível salvar o histórico', error);
  }
}

  function initSupport(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const launcher = root.querySelector('.ino-support__launcher');
    const panel = root.querySelector('.ino-support__panel');
    const closeButton = root.querySelector('.ino-support__close');
    const messages = root.querySelector('.ino-support__messages');
    const form = root.querySelector('.ino-support__form');
    const input = root.querySelector('textarea');
    const quickActions = root.querySelector('.ino-support__quick-actions');
    const submitButton = form?.querySelector('button[type="submit"]');

    if (!launcher || !panel || !closeButton || !messages || !form || !input || !quickActions || !submitButton) {
      console.error('[INOBOX Support] Elementos obrigatórios não encontrados', root);
      return;
    }

    root.dataset.initialized = 'true';

    const endpoint = (root.dataset.endpoint || '').replace(/\/$/, '');
    const fallbackWhatsApp = root.dataset.whatsapp || 'https://wa.me/553484131827';
    const sessionId = getSessionId();
      let conversationHistory = loadHistory(sessionId);

      function scrollMessagesToBottom() {
        window.requestAnimationFrame(() => {
          messages.scrollTop = messages.scrollHeight;

          window.setTimeout(() => {
            messages.scrollTop = messages.scrollHeight;
          }, 80);
        });
      }

    function setOpen(open) {
      panel.setAttribute('aria-hidden', String(!open));
      launcher.setAttribute('aria-expanded', String(open));
      root.classList.toggle('ino-support--open', open);

      if (open) {
        window.setTimeout(() => {
          scrollMessagesToBottom();

          if (!window.matchMedia('(max-width: 560px)').matches) {
            input.focus();
          }
        }, 80);
      }
    }

    function addMessage(text, role, whatsappUrl = null, persist = true) {
      const item = document.createElement('div');
      item.className = `ino-support__message ino-support__message--${role}`;

      const body = document.createElement('p');
      body.textContent = text;
      item.appendChild(body);

      if (whatsappUrl) {
        const link = document.createElement('a');
        link.href = whatsappUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'Continuar pelo WhatsApp';
        item.appendChild(link);
      }

      messages.appendChild(item);
      scrollMessagesToBottom();

      if (persist) {
        conversationHistory.push({
          text,
          role,
          whatsappUrl: whatsappUrl || null
        });

        conversationHistory = conversationHistory.slice(-MAX_HISTORY_MESSAGES);
        saveHistory(sessionId, conversationHistory);
      }
    }

    function setBusy(busy) {
      form.classList.toggle('is-busy', busy);
      input.disabled = busy;
      submitButton.disabled = busy;
    }

    async function sendMessage(rawMessage) {
      const message = String(rawMessage || '').trim();
      if (!message) return;

      addMessage(message, 'user');
      input.value = '';
      setBusy(true);

      if (!endpoint) {
        addMessage(
          'O atendimento online ainda não foi configurado. Você pode falar com a INOBOX pelo WhatsApp.',
          'assistant',
          fallbackWhatsApp
        );
        setBusy(false);
        return;
      }

      try {
        const response = await fetch(`${endpoint}/api/v1/chat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sessionId,
            message,
            page_url: window.location.href,
            page_title: document.title
          })
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.detail || 'Falha no atendimento');

        addMessage(data.reply || 'Recebi sua mensagem.', 'assistant', data.whatsapp_url || null);
      } catch (error) {
        console.error('[INOBOX Support]', error);
        addMessage(
          'Não consegui concluir o atendimento agora. Você pode continuar diretamente pelo WhatsApp da INOBOX.',
          'assistant',
          fallbackWhatsApp
        );
      } finally {
        setBusy(false);
        input.focus();
      }
    }

    launcher.addEventListener('click', () => {
      setOpen(!root.classList.contains('ino-support--open'));
    });
    closeButton.addEventListener('click', () => setOpen(false));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      sendMessage(input.value);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else submitButton.click();
      }
    });
    quickActions.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-message]');
      if (button) sendMessage(button.dataset.message || '');
    });

    if (conversationHistory.length > 0) {
      conversationHistory.forEach((item) => {
        addMessage(
          item.text,
          item.role,
          item.whatsappUrl || null,
          false
        );
      });
    } else {
      addMessage(
        'Olá! Sou o Assistente da INOBOX. Posso explicar como funciona, orientar sobre participação ou encaminhar você para nossa equipe. Como posso ajudar?',
        'assistant'
      );
    }

    console.info('[INOBOX Support] Widget inicializado');
  }

  function initAll(container = document) {
    container.querySelectorAll('[data-inobox-support-agent]').forEach(initSupport);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
